import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var InspectorObraComponent = /** @class */ (function () {
    function InspectorObraComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedIns = null;
        this.rut_insp = this.fb.group({
            rut: ['', [Validators.required, rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("inspectorObra"))) {
            localStorage.setItem("inspectorObra", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("inspectorObra"));
            console.log(this.rows);
        }
        this.invalidRut = true;
        this.inspector_obra = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
    }
    InspectorObraComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    InspectorObraComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    InspectorObraComponent.prototype.get_inspector_obra = function (rut) {
        var _this = this;
        this.spinner.show();
        this.cleanData();
        this._userService.getinspector_obra(rut).subscribe(function (response) {
            if (response.message) {
                _this.inspector_obra.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.inspector_obra.rut = response.rut ? response.rut : '';
                _this.inspector_obra.nombre = response.nombre ? response.nombre : '';
                _this.inspector_obra.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.inspector_obra.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.inspector_obra.direccion = response.direccion ? response.direccion : '';
                _this.inspector_obra.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.inspector_obra.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.inspector_obra.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.inspector_obra.comuna = response.comuna ? response.comuna : '';
                _this.inspector_obra.fono = response.fono ? response.fono : '';
                _this.inspector_obra.mail = response.mail ? response.mail : '';
                _this.inspector_obra.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    InspectorObraComponent.prototype.cleanData = function () {
        this.inspector_obra = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
        this.rut_insp.reset();
    };
    InspectorObraComponent.prototype.update_inspector_obra = function (rut, id) {
        this.get_inspector_obra(rut);
        this.selectedIns = id;
    };
    InspectorObraComponent.prototype.saveinspector_obra = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.inspector_obra.rut == this.rows[x].rut) {
                this.delete_inspector_obra(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedIns != null) {
            this.delete_inspector_obra(this.selectedIns);
            this.selectedIns = null;
        }*/
        this.spinner.show();
        this._userService.saveinspector_obra(this.inspector_obra).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#rep_modal").modal("hide");
                _this.actualRow = localStorage.getItem("inspectorObra");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.inspector_obra.rut,
                    nombre: _this.inspector_obra.nombre,
                    apellido_pat: _this.inspector_obra.apellido_pat,
                    apellido_mat: _this.inspector_obra.apellido_mat,
                    direccion: _this.inspector_obra.direccion,
                    direccion_num: _this.inspector_obra.direccion_num,
                    direccion_complemento: _this.inspector_obra.direccion_complemento,
                    direccion_completa: _this.inspector_obra.direccion_completa,
                    comuna: _this.inspector_obra.comuna,
                    fono: _this.inspector_obra.fono,
                    mail: _this.inspector_obra.mail
                });
                localStorage.setItem("inspectorObra", JSON.stringify(_this.rows));
                _this.inspector_obra = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
                _this.rut_insp.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    InspectorObraComponent.prototype.delete_inspector_obra = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("inspectorObra", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('inspectorObra'));
            }
        }
    };
    InspectorObraComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return InspectorObraComponent;
}());
export { InspectorObraComponent };
